import { LearningSystemImpl } from './core/learning-system';
// Create a singleton instance of LearningSystemImpl
export const _learningSystem = new LearningSystemImpl();
// Export types and implementation
export { LearningSystemImpl };
export type { LearningSystem } from './types';
export * from './hooks';
